module.exports = __webpack_public_path__ + "img/proyectos3.c8edb245.png";